import { styled } from '@goodfynd/theme';
import Popover from '@mui/material/Popover';

export const StyledPopover = styled(Popover, {
  '.MuiPopover-paper': {
    padding: 24,
    marginTop: 8,
    borderRadius: 12,
    width: 435,
    height: 436,
  },
});
